import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-bugs-card',
  templateUrl: './bugs.component.html'
})
export class BugsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
